export default "__VITE_ASSET__vzQw$TEm__"